// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

export const LIST_COMPLIANCE_FRAMEWORKS_V_2 =
  "mondoo.policy.ExtendedHub.ListComplianceFrameworksV2";
